// removed by extract-text-webpack-plugin
module.exports = {"Children":"Child__Children__9WRs7","ChildrenInner":"Child__ChildrenInner__39CqQ","ChildrenInner2":"Child__ChildrenInner2__2Pvcp","Btn":"Child__Btn__29jfo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChildController/Child/Child.css
// module id = 107
// module chunks = 0